var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReserve(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.846 5.192A1.846 1.846 0 001 7.04v16.615A1.846 1.846 0 002.846 25.5h20.308A1.846 1.846 0 0025 23.654V7.039a1.846 1.846 0 00-1.846-1.847h-3.692M6.539 1.5v7.385M19.461 1.5v7.385M6.539 5.192h9.23",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.539 15.346a.923.923 0 100-1.846.923.923 0 000 1.846zM13 15.346a.923.923 0 100-1.846.923.923 0 000 1.846zM19.462 15.346a.923.923 0 100-1.846.923.923 0 000 1.846zM6.539 20.885a.923.923 0 100-1.847.923.923 0 000 1.847z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgReserve;